import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import ChargeStationList from './charge_station_list';
import ChargeStationView from './charge_station_view';

export default function ChargeStation() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = ChargeStationList;
      break;

    case 'view':
      ActualPage = ChargeStationView;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

